module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-ties.7b5713c0.png";